var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"save",class:{ 'save-isDisabled': _vm.disabled },style:({ width: _vm.width }),on:{"click":function($event){$event.stopPropagation();return _vm.emitEvent($event)}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }